export const fileToBase64 = (file, { onReaderLoad, onReaderLoadStart } = {}) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    const resolveParsedBase64 = () => resolve(reader.result.split(',')[1]);
    reader.onload = (progressEvent) => {
        if (onReaderLoad) {
            return onReaderLoad({ reader, resolveParsedBase64, progressEvent });
        }
        return resolveParsedBase64();
    };
    reader.onloadstart = (progressEvent) => {
        if (onReaderLoadStart) {
            onReaderLoadStart({ reader, progressEvent });
        }
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
});
export default fileToBase64;
